<div class="container-fluid">
  <div class="row">
    <div class="col-12">
      <div class="row">
        <div class="col-9">
          <h5 class=""><i class="fa fa-cogs"></i><b> Data Extracts:</b> Run extracts</h5>
        </div>
        <div class="col-3 text-right">
          <strong class="text-right" style="color:rgb(253, 207,76 );"></strong>
        </div>

      </div>
      <div class="cover-x" style="position: absolute; right: 3px; top: -1px; z-index: 9;">
        <div class="main-btn rounded-circle rmp-all" (click)="back()" title="Go back" style="margin: 0px auto!important;" rel="tooltip" data-placement="top">
          <span class="fa fa-arrow-left fa-2x" style="margin:5.5px auto;color:white!important;" aria-hidden="true"></span>
        </div>
        <div class="lbl-app" style="margin: 1px auto;">
          <span>Back</span>
        </div>
      </div>
      <hr/>
      <div style="height: 100vh; width: 100%;  border: 0; box-shadow: 0;" >
        <iframe style="border: 0; box-shadow: 0;" [src]="iframeUrl"  height="100%" width="100%" name="ifRptListing">
          <p>Your browser does not support iframes.</p>
        </iframe> 
      </div>
    </div>
  </div>
</div>
